/** Public site identity — used by client UI and server email. */
export const SITE_NAME = "KPKL Radio";
export const SITE_DOMAIN = "kpklradio.com";
export const SITE_URL = `https://${SITE_DOMAIN}`;
export const SITE_TAGLINE = "Sounds of the Court";
